export function replaceSpecialCharacters(text) {
    return text.replace(/['()*]/g, (char) => `%${char.codePointAt(0)?.toString(16).toUpperCase()}`);
}
